import { render, staticRenderFns } from "./activities-details.vue?vue&type=template&id=b21a6824&scoped=true"
import script from "./activities-details.vue?vue&type=script&lang=js"
export * from "./activities-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21a6824",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b21a6824')) {
      api.createRecord('b21a6824', component.options)
    } else {
      api.reload('b21a6824', component.options)
    }
    module.hot.accept("./activities-details.vue?vue&type=template&id=b21a6824&scoped=true", function () {
      api.rerender('b21a6824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/components/activities/activities-details.vue"
export default component.exports